module.exports = __webpack_public_path__ + "assets/images/rbyearend-09.jpg?v=5f750015";